import { BoxProps, LinkProps } from '@chakra-ui/react';
import { Button } from './styles';

export interface ButtonProps {
    children?: React.ReactNode;
    style: 'default' | 'outline' | 'outline-reverted';
    href?: string;
    target: string;
    onClick?: any;
    marginBottom?: string;
}

const StyledButton: React.FC<ButtonProps> = ({
    children,
    style,
    href,
    target,
    onClick,
    marginBottom,
}) => {
    return (
        //TODO  Przepisać na chakra UI
        <Button
            href={href}
            $style={style}
            target={target}
            onClick={onClick}
            style={{ marginBottom: marginBottom }}
        >
            {children}
            {style === 'default' ? (
                <svg
                    width="9"
                    height="14"
                    viewBox="0 0 9 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                </svg>
            ) : (
                <svg
                    width="9"
                    height="14"
                    viewBox="0 0 9 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                </svg>
            )}
        </Button>
    );
};

export default StyledButton;
